import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownExpenseCategory, EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiDeleteExpense, ApiGetExpense, ApiInsertExpense, ApiUpdateExpense } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { GetStatus, money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import { ExpenseService } from "services/ExpenseService"
import { MainBodyCard } from "components/Cards/MainBodyCard"
import { useModal } from "utils/context/ModalContext"
import { PagesFormTitle } from "components/Cards/PagesFormTitle"
import { FormCard } from "components/Cards/FormCard"

export default function ExpenseForm(){
    const navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchCreateExpense, fetchUpdateExpense, fetchDeleteExpense, fetchExpenseById } = ExpenseService()

    const { fetch: insertExpense } = useFetch(ApiInsertExpense)
    const { fetch: updateExpense } = useFetch(ApiUpdateExpense)
    const { fetch: deleteExpense } = useFetch(ApiDeleteExpense)
    const { fetch: getExpense } = useFetch(ApiGetExpense)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let expenseId = queryString.get("expenseId")

    const [expenseDate, setExpenseDate] = useState(new Date())
    const [expenseCategory, setExpenseCategory] = useState(EmptyString)
    const [amount, setAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)

    // HEADER
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const expenseDateChange = (e) => { 
        if (e === null){
            setExpenseDate(new Date()) 
        }else{
            setExpenseDate(e)
        }
    }
    const expenseCategoryChange = (e) => { setExpenseCategory(e.value) }
    const amountChange = (e) => { setAmount(money(e.target.value)) }
    const remarkChange = (e) => { setRemark(e.target.value.toUpperCase()) }
    

    const saveBtnClick = async () => {
        if (!validateForm()) return
                
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            if (formType === FormTypeAdd){
                await fetchCreateExpense(
                    expenseDate,
                    expenseCategory,
                    amount.replaceAll(",", ""),
                    remark
                )
            }else{
                await fetchUpdateExpense(
                    expenseId,
                    expenseDate,
                    expenseCategory,
                    amount.replaceAll(",", ""),
                    remark
                )
            }
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/expense')
                }
            })
        }
        
    }
    const deleteBtnClick = async () => { 
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeleteExpense(expenseId, status)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/expense')
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        // if (tenantName === EmptyString){
        //     errorCount++
        //     setErrorTenantName(true)
        // }else{
        //     setErrorTenantName(false)
        // }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    const getExpenseById = async () => {
        const res = await fetchExpenseById(expenseId)
        if (!res) return

        const data = res.data
                
        setExpenseDate(data.expenseDate)
        setExpenseCategory(data.expenseCategory)
        setAmount(money(data.amount))
        setRemark(data.remark)
        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                if (formType ===  FormTypeEdit){
                    await getExpenseById()
                } 
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Payment Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />
            

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Expense Date'>
                    <DatePicker className="w-full h-10 bg-white" value={expenseDate} onChange={expenseDateChange} />
                </FormCard>

                <FormCard title='Expense Type'>
                    <Dropdown className="" options={DropdownExpenseCategory} value={expenseCategory} onChange={expenseCategoryChange} placeholder="Select Expense Category" />
                </FormCard>

                <FormCard title='Amount'>
                    <div className="flex rounded-md w-full border border-app-light-grey">
                        <div className="py-2 px-4 border-r">
                            <span>Rp</span>
                        </div>
                        <input className="bg-white w-full px-4 py-2 text-right" value={amount} onChange={amountChange} />
                    </div> 
                </FormCard>

                <FormCard title='Remark'>
                    <input className="input" value={remark} onChange={remarkChange} />
                </FormCard>

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false)} />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
        </MainBodyCard>
    )
}